import globalCSSStyleSheetUrl from "pixel/globalCSSStyleSheetUrl";
import __ from "standard/dunder";

const paint = (target, propertyKey, descriptor) => {
  const next = descriptor.value;

  Reflect.defineProperty(target, __.paint__, {
    value() {
      return this[propertyKey](...arguments);
    },
  });

  Object.assign(descriptor, {
    value() {
      requestAnimationFrame(async () => {
        await this[__.willPaint__]?.();
        this[__.content__] = await Reflect.apply(next, this, arguments);
        (this.shadowRoot ?? this).innerHTML =
          `<style>@import url("${globalCSSStyleSheetUrl()}");</style>${
            this[__.content__]
          }`;
        await this[__.didPaint__]?.();
      });
    },
  });
};

export default paint;
